/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SentenceStatus = zod.enum(['proposed', 'accepted', 'rejected', 'completed']);

export type SentenceStatus = zod.input<typeof SentenceStatus>;
export type SentenceStatusOutput = zod.output<typeof SentenceStatus>;
